export default __webpack_public_path__ + "static/media/5.8ab6bc56.jpg";